module.exports = __webpack_public_path__ + "static/media/listView.43cd1cd2.svg";